// Module
var code = "<template> <raago-container> <raago-spacing vertical=\"m\"> <h3>${'screen.notFound.header' & t}</h3> Siden du spør etter ble ikke funnet. Gå til <a route-href=\"route: home\">forsiden</a>. </raago-spacing> </raago-container> </template>";
// Exports
export default code;